import { Component } from '@angular/core';
import { CoreService } from '@app/modules/core/services/core.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent {

  constructor(public coreService: CoreService) { }

}
